<template>
  <nav class="navbar bg-body-light">
    <div class="container">
      <img v-if="joinUrl==='hmm'" src="../assets/terms_logo.png" alt="화물맨" width="40"/>
      <img v-else-if="joinUrl === 'mancharo'" src="../assets/main_mancharo_icon.png" alt="만차로" width="40"/>
      <img v-else-if="joinUrl === 'atl'" src="../assets/terms_logo.png" alt="화물맨" width="40"/>
      <span v-if="jibuName" class="jibu-name">{{ jibuName }}</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainHeader",
  data(){
    return {
      joinUrl: '',
      jibuName: ''
    }
  },
  mounted() {
    this.joinUrl = this.$store.getters.getJoinUrl;
    // sessionStorage에서 지부명 가져오기
    this.jibuName = sessionStorage.getItem('jibu-name') || '';
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
}

.jibu-name {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
</style>